import React, { ReactElement, useEffect, useRef } from "react";
import customProtocolCheck from "custom-protocol-check";
import { useParams } from "react-router-dom";
import { RouteNameType, RouteParams, useReplaceHistory } from "../utils/routes";
import { checkInviteURL, refreshToken } from "@obsbot/remo-server-api";
import { eventBus } from "@obsbot/remo-utils";
import { useTranslate } from "@obsbot/remo-i18n";
import { useGlobalStore } from "@obsbot/remo-stores";

interface ChannelInvitePageProps {}

const ChannelInvitePage: React.FC<ChannelInvitePageProps> = (): ReactElement => {
    const params = useParams<RouteParams<RouteNameType.ChannelInvitePage>>();
    const lastParamsRef = useRef("");
    const replaceHistory = useReplaceHistory();
    const t = useTranslate();
    useEffect(() => {
        const checkProtocol = async (): Promise<void> => {
            const roomKey = params.roomKey;
            if (roomKey && lastParamsRef.current === "") {
                lastParamsRef.current = roomKey;
                const checkResult = await checkInviteURL(roomKey);
                if (checkResult.data) {
                    const roomUUID = checkResult.data;
                    const protocolURL = `x-remo-obsbot-nexus://joinRoom?channelId=${roomUUID}`;
                    customProtocolCheck(
                        protocolURL,
                        async () => {
                            const refresh_token = localStorage.getItem("refresh_token");
                            const globalStore = useGlobalStore.getState();
                            if (!refresh_token || !globalStore.userInfo) {
                                useGlobalStore.getState().updateToJoinRoomUUID(roomUUID);
                                replaceHistory(RouteNameType.LoginPage);
                                return;
                            }
                            try {
                                const { token } = await refreshToken({
                                    refresh_token,
                                    client_type: (window as any).isElectron ? "game_client" : "web",
                                });
                                globalStore.updateUserToken(token);
                                localStorage.setItem("token", token);
                                if (token) {
                                    const { data } = await globalStore.getSdkID();
                                    globalStore.getUserInfo(globalStore.userInfo?.notSet || false);
                                    globalStore.updateRTCInfo({
                                        userSig: data.userSig,
                                        uid: globalStore.userInfo!.user_id,
                                    });
                                    globalStore.updateServerRegionConfig({
                                        tencent: { appId: data.sdkAppId },
                                    });
                                    globalStore.updateOnlineStatus("online");
                                    replaceHistory(RouteNameType.ChannelRoomPage, {
                                        roomUUID,
                                    });
                                }
                            } catch (error) {
                                useGlobalStore.getState().updateToJoinRoomUUID(roomUUID);
                                replaceHistory(RouteNameType.LoginPage);
                            }
                        },
                        () => {
                            // success call application
                        },
                        500,
                        () => {
                            eventBus.emit("show-message", {
                                message: t("browser-not-support"),
                                type: "error",
                            });
                        },
                    );
                } else if (checkResult.data === null) {
                    eventBus.emit("show-message", {
                        message: t("invalid-invite-url"),
                        type: "error",
                    });
                } else if (checkResult.data === false) {
                    eventBus.emit("show-message", {
                        message: t("invite-url-expired"),
                        type: "error",
                    });
                }
            } else {
                eventBus.emit("show-message", {
                    message: t("invalid-invite-url"),
                    type: "error",
                });
            }
        };
        checkProtocol();
    }, [params, t, replaceHistory]);
    return <div></div>;
};

export default ChannelInvitePage;
